// Recovered compiled webpack factory 68451. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "reducer", {
      enumerable: !0,
      get: function () {
        return f;
      },
    }));
  let n = r(86871),
    a = r(35737),
    o = r(36798),
    i = r(37854),
    s = r(38719),
    l = r(43933),
    u = r(65345),
    c = r(62244),
    f = function (e, t) {
      switch (t.type) {
        case n.ACTION_NAVIGATE:
          return (0, a.navigateReducer)(e, t);
        case n.ACTION_SERVER_PATCH:
          return (0, o.serverPatchReducer)(e, t);
        case n.ACTION_RESTORE:
          return (0, i.restoreReducer)(e, t);
        case n.ACTION_REFRESH:
          return (0, s.refreshReducer)(e, t);
        case n.ACTION_HMR_REFRESH:
          return (0, u.hmrRefreshReducer)(e, t);
        case n.ACTION_PREFETCH:
          return (0, l.prefetchReducer)(e, t);
        case n.ACTION_SERVER_ACTION:
          return (0, c.serverActionReducer)(e, t);
        default:
          throw Object.defineProperty(Error("Unknown action"), "__NEXT_ERROR_CODE", {
            value: "E295",
            enumerable: !1,
            configurable: !0,
          });
      }
    };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
